import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Layui from '@layui/layui-vue'
import layer from '@layui/layer-vue';
import '@layui/layui-vue/lib/index.css'
import '@/permission' 

createApp(App).use(router).use(Layui).use(layer).mount('#app')
